import http from '../utility/http';

export default {
    namespaced: true,
    state: {
        error: undefined,
        current: localStorage.getItem('truthtree-session'),
        signedUp: false
    },
    getters: {
        getCurrent: (state) => {
            return state.currentUser;
        },
    },
    actions: {
        async login(context, user) {
            try {
                await http.post('/login', {
                    email: user.email,
                    password: user.password
                });
                localStorage.setItem('truthtree-session', true)
                context.commit('setCurrent', true);
            } catch (error) {
                context.commit('error', error);
            }
        },
        async logout(context) {
            try {
                await http.post('/logout');
                localStorage.removeItem('truthtree-session');
                context.commit('setCurrent', undefined);
            } catch (error) {
                context.commit('error', error);
            }
        }
    },
    mutations: {
        setCurrent(state, session) {
            state.current = session;
        },
        error(state, error) {
            state.error = error;
        }
    }
}